/* eslint-disable */
import React from "react";
import {useTranslation} from "react-i18next";
import {TextField} from "mui-rff";
import {padWithZeros} from "@/utils";
import MenuItemModalForm from "@/components/modal/MenuItemModalForm";
import {Form} from "react-final-form";
import SimpleSpinner from "@/components/spinner/simpleSpinner";
import {Grid} from "@mui/material";
import {LoadingButton} from "@mui/lab";

const ExtraFieldsForm = (
    {
        countExtraFields,
        validateForm,
        required,
        onSubmit,
        initialValues,
        submitting,
        isModal,
        closePopover,
        setModalOpen,
        loading
    }: any
): any => {
    //console.log(`required`, required);

    const {t} = useTranslation();

    let formFields: any[] = [];

    for (let i = 0; i < countExtraFields; i++) {
        const current: number = i + 1;
        const fieldNumber = padWithZeros(current, 2);
        formFields[i] = {
            field:
                <TextField
                    InputLabelProps={{shrink: true}}
                    label={`Campo extra ${fieldNumber}`}
                    name={`campo${current}`}
                    required={required[`campo${current}`]}
                />
        };
    }

    //console.log('initialValues', initialValues);

    const modalProps: any = {
        hasMenuItem: true,
        label: 'Campos extra',
        title: 'Campos extra',
        formFields,
        onSubmit,
        initialValues,
        validateForm,
        required,
        submitting,
        closePopover,
        setModalOpen,
        loading
    };

    return (
        <>
            {
                !isModal &&
                <Form
                    onSubmit={onSubmit}
                    initialValues={initialValues}
                    validate={validateForm}
                    render={({handleSubmit}) => {
                        //console.log('s1 errors', errors);
                        return (
                            <>
                                {loading && <SimpleSpinner/>}
                                {!loading &&
                                    <form onSubmit={handleSubmit} noValidate>
                                        <Grid container spacing={2}>
                                            {formFields.map((item, idx) => (
                                                <Grid item md={4} sm={12} xs={12} key={idx}>
                                                    {item.field}
                                                </Grid>
                                            ))}
                                        </Grid>
                                        <LoadingButton
                                            sx={{mt: 3, mr: 1}}
                                            //fullWidth
                                            size="large"
                                            type="submit"
                                            variant="contained"
                                            loading={submitting}
                                        >
                                            {t("common.save")}
                                        </LoadingButton>
                                    </form>
                                }
                            </>
                        );
                    }}
                />
            }

                {
                    isModal &&
                    <MenuItemModalForm
                        {...modalProps}
                    />
                }
        </>
    );
}

export default ExtraFieldsForm;